// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'report.page.title.service-price-list': 'Service Price List',
    'report.page.title.inventory-report': 'Inventory Report',

    'report.label.service': 'Service',
    'report.label.product': 'Product',
    'report.label.cost': 'Cost',

    'report.message.no_services': 'No services have been made as yet',
};
